let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bWMh7")).then(() => parcelRequire('5tdkd'));